module.exports = __webpack_public_path__ + "static/media/dekra-logo-vertical-charcoal.ffbb08a9.svg";